<template>
    <div class="NoteView note_view_wrap">
        <KvTable :items="drawNoteDetail"></KvTable>
    </div>
</template>
<script>
    import KvTable from '@/components/Table/kvTable/index'

    export default {
        name: `NoteView`,
        props: [ 'notes', 'selectedIdx' ],
        components: { KvTable },
        data() {
            return {
                noteTitle: '',
                createdDatetime: '',
                noteContent: ''
            }
        },
        methods: {
            changeNoteComponent( noteIdx, idx ) {
                this.$emit( `changeNoteComponent`, noteIdx, idx );
            },
        },
        computed: {
            drawNoteDetail() {
              return [
                {
                  index: 0,
                  keyTitle: this.$t('title'),
                  keyType: 'Default',
                  class: [],
                  keyRange: [],
                  values: this.notes[this.selectedIdx].noteTitle
                }, {
                  index: 1,
                  keyTitle: this.$t('table.header.created_on'),
                  keyType: 'Default',
                  class: [],
                  keyRange: [],
                  values: this.moment(this.notes[this.selectedIdx].createDatetime).locale(this.$t('country')).format('lll')
                }, {
                  index: 2,
                  keyTitle: this.$t('details'),
                  keyType: 'Default',
                  class: [],
                  parentClass: ['columns_2', 'flex-col',],
                  keyRange: [],
                  values: this.notes[this.selectedIdx].noteContent
                }];
            }
        },
    }

</script>

<style lang="scss">
.NoteView {
  flex: 7 7 5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: stretch;
  align-items: stretch;

  .table-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 80px;
    width: 100%;
    overflow: hidden;
    flex: 1 1 1rem;

    .note_view_scroll {
      overflow: scroll;
    }

    .item-parent {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0.5rem;
      text-align: left;
      border-bottom: 1px solid var(--grey20);
      padding-bottom: 15px;

      &.columns_2 {
        grid-column: 1/3;
      }

      &.row_2 {
        grid-row: 1/3;
      }

      .item-title {
        flex: 1 1 1rem;
        font-weight: 700;
      }

      .item-value {
        flex: 5 3 1rem;
      }

      &.flex-col {
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;

        .item-title {
          margin-bottom: 1rem;
          flex: 0 0 0;
        }

        .item-value {
          margin-bottom: 1rem;
          white-space: pre-line;
          width: 100%;
          overflow: auto;

        }
      }

      &:nth-child(2) {
        .item-title {
          flex: 1 1 2rem;
        }

        .item-value {
          flex: 5 3 1rem;
        }
      }
    }
  }
}
</style>